import { logEvent, LogLevel } from '@praxis/component-logging'
import axios from 'axios'
import _ from 'lodash'
import { config } from '../App'
import appConfig from '../config/appConfig'
import { toast } from 'react-toastify'

const qs = require('qs')

/**
 * Private method to remove specified headers from main config
 * @param {*} extraHeaderList
 */
function removeModifiedHeader(extraHeaderList) {
  if (extraHeaderList && extraHeaderList.length > 0) {
    extraHeaderList.forEach((eachHeaderElement) => {
      _.unset(config, eachHeaderElement.name, eachHeaderElement.value)
    })
  }
}

const customId = `toastId-${Math.random()}`
const showToastMessage = (error) => {
  if (error.response?.status >= 500) {
    toast.error(
      <div>
        <strong className="hc-clr-contrast">System error</strong>
        <p>Something went wrong!</p>
      </div>,
      {
        position: 'top-center',
        toastId: customId,
      },
    )
  }
}

export const requestInterceptor = async (session) => {
  const applicationConfig = await appConfig()
  axios.interceptors.request.use(
    (config) => {
      if (config && config.headers) {
        if (session && session.accessToken) {
          config.headers['x-api-key'] = applicationConfig.apiKey
        }
        return config
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )
}

/**
 * Handle generic POST
 * @param {*} url
 * @param {*} requestParams
 * @param {*} extraHeaderList
 * @param {*} requestBody
 */
export function handlePost(url, requestParams, extraHeaderList, requestBody) {
  if (requestParams) {
    config.params = requestParams
  }
  if (extraHeaderList && extraHeaderList.length > 0) {
    extraHeaderList.forEach((eachHeaderElement) => {
      _.set(config, eachHeaderElement.name, eachHeaderElement.value)
    })
  }

  return axios
    .post(url, requestBody, config)
    .then(function (response) {
      removeModifiedHeader(extraHeaderList)
      return Promise.resolve(response.data)
    })
    .catch((error) => {
      removeModifiedHeader(extraHeaderList)
      logErrorApiCalls(error)
      showToastMessage(error)
      return Promise.reject(error)
    })
}

/**
 * Handle get request
 * @param {*} url
 * @param {*} params
 * @param {*} responseType
 * @returns
 */
export function handleGet(url, params = {}, responseType = 'json') {
  return axios
    .get(
      url,
      {
        params: params,
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        },
        responseType: responseType,
      },
      config,
    )
    .catch((error) => {
      logErrorApiCalls(error)
      return Promise.reject(error)
    })
}

/**
 * Handle generic POST
 * @param {*} url
 * @param {*} requestParams
 * @param {*} extraHeaderList
 * @param {*} requestBody
 */
export function handlePut(url, requestParams, extraHeaderList, requestBody) {
  if (requestParams) {
    config.params = requestParams
  }
  if (extraHeaderList && extraHeaderList.length > 0) {
    extraHeaderList.forEach((eachHeaderElement) => {
      _.set(config, eachHeaderElement.name, eachHeaderElement.value)
    })
  }

  return axios
    .put(url, requestBody, config)
    .then(function (response) {
      removeModifiedHeader(extraHeaderList)
      return Promise.resolve(response.data)
    })
    .catch((error) => {
      removeModifiedHeader(extraHeaderList)
      logErrorApiCalls(error)
      showToastMessage(error)
      return Promise.reject(error)
    })
}

/**
 * Handle generic DELETE
 * @param {*} url
 * @param {*} requestPayload
 * @param {*} params
 * @param {*} responseType
 * @returns
 */
export function handleDelete(
  url,
  requestPayload = null,
  params = {},
  responseType = 'json',
) {
  return axios
    .delete(
      url,
      { data: requestPayload },
      {
        params: params,
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        },
        responseType: responseType,
      },
      config,
    )
    .catch((error) => {
      logErrorApiCalls(error)
      showToastMessage(error)
      return Promise.reject(error)
    })
}

/**
 * Log API error calls
 * @param {*} error
 */
export const logErrorApiCalls = (error) => {
  let loggingInfo
  if (error.response) {
    // The request was made and the server responded with a status code that falls out of the range of 2xx
    let errorMsg = error.response.data
      ? error.response.data.message
      : 'No error message available'
    let path = error.response.data
      ? error.response.data.path
      : window.location.origin
    loggingInfo = {
      message:
        'Error occured while fetching data from ' +
        path +
        ' with the message ' +
        errorMsg,
      error: error,
    }
    console.log('error', loggingInfo)
  } else {
    // Something happened in setting up the request that triggered an Error
    loggingInfo = {
      message: error.message,
    }
  }
  const optionalLoggingOptions = {
    level: LogLevel.Error,
  }
  logEvent(loggingInfo, optionalLoggingOptions)
}
